import { Trans } from "@lingui/react/macro";
import { SearchIcon } from "lucide-react";
import Heading from "./heading";
import IndexForm from "./index-form";

export default function SearchIndex() {
  return (
    <div className="flex-1 flex justify-center items-center p-4 lg:p-6">
      <div className="w-full max-w-180 flex flex-col items-center justify-center gap-6">
        <div className="flex flex-col items-center text-center gap-4">
          <div className="size-12 flex items-center justify-center shadow border rounded-md">
            <SearchIcon className="size-6" />
          </div>
          <div className="flex flex-col items-center text-center gap-2">
            <Heading />
            <p className="text-muted-foreground text-balance">
              <Trans>
                Utforska omnämnanden från poddar, sociala medier, nyheter, radio
                och TV i realtid.
              </Trans>
            </p>
          </div>
        </div>

        <IndexForm />
      </div>
    </div>
  );
}
